import { render, staticRenderFns } from "./stopPromotionDialog.vue?vue&type=template&id=013ff242&scoped=true"
import script from "./stopPromotionDialog.vue?vue&type=script&lang=js"
export * from "./stopPromotionDialog.vue?vue&type=script&lang=js"
import style0 from "./stopPromotionDialog.vue?vue&type=style&index=0&id=013ff242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ff242",
  null
  
)

export default component.exports